// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`1.1|136.0000|0.0|136.0000|.0.0|H|N|
2.1|136.0000|0.0|136.0000|.0.0|H|N|
3.1|136.0000|0.0|136.0000|.0.0|H|N|
4.1|136.0000|0.0|136.0000|.0.0|H|N|
5.1|136.0000|0.0|136.0000|.0.0|H|N|
6.1|136.0000|0.0|136.0000|.0.0|H|N|
7.1|136.0000|0.0|136.0000|.0.0|H|N|
8.1|136.0000|0.0|136.0000|.0.0|H|N|
9.1|136.0000|0.0|136.0000|.0.0|H|N|
10.1|151.35500|103.5|159.30000|000.0|H|N|
10.2|151.26500|103.5|159.33000|000.0|H|N|
10.3|151.34000|103.5|159.34500|000.0|H|N|
10.4|151.40000|103.5|159.37500|000.0|H|N|
10.5|151.25000|103.5|159.36000|000.0|H|N|
10.6|151.46000|103.5|159.39000|000.0|H|N|
10.7|151.44500|103.5|159.34500|000.0|H|N|
10.8|151.17500|103.5|159.45000|000.0|H|N|
10.9|151.19000|103.5|159.22500|000.0|H|N|
10.10|151.16750|103.5|159.39750|000.0|L|N|Portable Repeater Use Only
10.11|151.24250|103.5|159.2625|000.0|H|N|
10.12|151.25750|192.8|151.25750|192.8|L|N|
10.13|151.16000|192.8|151.16000|192.8|L|N|
10.14|151.17500|192.8|151.17500|192.8|L|N|
10.15|151.19000|192.8|151.19000|192.8|L|N|
10.16|151.25000|192.8|151.25000|192.8|L|N|
10.17|151.32500|192.8|151.32500|192.8|L|N|
10.18|151.34000|192.8|151.34000|192.8|L|N|
10.19|151.37000|192.8|151.37000|192.8|L|N|
10.20|151.38500|192.8|151.38500|192.8|L|N|
10.21|151.40000|192.8|151.40000|192.8|L|N|
10.22|151.44500|192.8|151.44500|192.8|L|N|
10.23|151.46000|192.8|151.46000|192.8|L|N|
10.24|159.29250|192.8|159.29250|192.8|L|N|
10.25|159.30750|192.8|159.30750|192.8|L|N|
10.26|151.18250|192.8|151.18250|192.8|L|N|
10.27|151.34750|192.8|151.34750|192.8|L|N|
10.28|151.39250|192.8|151.39250|192.8|L|N|
10.29|159.38250|192.8|159.38250|192.8|L|N|
10.30|151.24250|192.8|151.24250|192.8|L|N|
10.31|159.24750|192.8|159.24750|192.8|L|N|
10.32|151.46750|192.8|151.46750|192.8|L|N|
10.33|159.32250|192.8|159.32250|192.8|L|N|
10.34|151.15250|192.8|151.15250|192.8|L|N|
10.35|159.33750|192.8|159.33750|192.8|L|N|
10.36|151.14500|192.8|151.14500|192.8|L|N|
10.37|151.47500|192.8|151.47500|192.8|L|N|
10.38|159.29250|67.0|159.29250|67.0|L|N|
10.39|159.30750|67.0|159.30750|67.0|L|N|
10.40|151.18250|67.0|151.18250|67.0|L|N|
10.41|151.34750|67.0|151.34750|67.0|L|N|
10.42|151.39250|67.0|151.39250|67.0|L|N|
10.43|159.38250|67.0|159.38250|67.0|L|N|
10.44|151.24250|67.0|151.24250|67.0|L|N|
10.45|159.24750|67.0|159.24750|67.0|L|N|
10.46|151.46750|67.0|151.46750|67.0|L|N|
10.47|159.32250|67.0|159.32250|67.0|L|N|
10.48|151.15250|67.0|151.15250|67.0|L|N|
10.49|159.33750|67.0|159.33750|67.0|L|N|
10.50|151.14500|67.0|151.14500|67.0|L|N|
10.51|151.47500|67.0|151.47500|67.0|L|N|
10.52|153.75500|000.0|154.98000|000.0|H|N|Travel Net
10.53|136.00000|000.0|136.00000|000.0|H|N|STATEWIDE LOAD
10.54|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
